import moment from "moment";
import api from "./Api";
const Case = process.env.REACT_APP_CASE_URL || "";
const caseAPI = api(Case);
const Picklist = process.env.REACT_APP_PICKLIST_URL || ""; // Default to an empty string or another default value

const picklistAPI = api(Picklist);
// Define a generic API response type
export type ApiResponse<T> = {
  isSuccess: boolean;
  statusCode: number;
  message: string;
  result: T;
};

export const addCaseNotes = async (
  noteData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await caseAPI.post<ApiResponse<any>>(
      "/api/case/notes/add",
      noteData
    );
    const { isSuccess, statusCode, message, result } = response.data;
    return { isSuccess, statusCode, message, result };
  } catch (error) {
    console.error("Error adding case notes:", error);
    throw new Error(
      "Failed to add the case notes. Please check the data and try again."
    );
  }
};
export interface DocumentCategoryItem {
  documentTypeId: number;
  documentType: string;
  documentCategory: string;
  documentTypeDescription: string;
  sortSequence: number;
  responseCode: number;
  responseMessage: string;
}

export interface DocumentTypeOption {
  CategaryID: number;
  value: number;
  label: string;
  documentCategory: string;
  documentTypeDescription: string;
}

const fetchPickListByGroupName = async (params: any): Promise<any> => {
  try {
    const response = await picklistAPI.post(
      "/api/picklist/items/bygroupname",
      params
    );
    // Map the result to transform pickListItemId into value and displayName into label
    const genderList = response.data?.result.map((item: any) => ({
      value: item.pickListItemId,
      label: item.displayName,
    }));

    return genderList;
  } catch (error) {
    console.error("Error fetching the data:", error);
    throw new Error("Unable to fetch the data. Please try again later.");
  }
};

export const getDocumentCategoryList = async (): Promise<
  DocumentTypeOption[]
> => {
  try {
    const response = await caseAPI.get<ApiResponse<DocumentCategoryItem[]>>(
      "/api/case/record/document/category"
    );

    const uniqueMap = new Map<number, DocumentCategoryItem>();

    response.data.result.forEach((item) => {
      if (!uniqueMap.has(item.documentTypeId)) {
        uniqueMap.set(item.documentTypeId, item);
      }
    });

    return Array.from(uniqueMap.values()).map((item) => ({
      CategaryID: item.documentTypeId,
      value: item.documentTypeId, // updated line
      label: item.documentCategory,
      documentCategory: item.documentCategory,
      documentTypeDescription: item.documentTypeDescription,
    }));
  } catch (error) {
    console.error("Error fetching document categories:", error);
    throw new Error("Failed to fetch document categories.");
  }
};
export const uploadCaseRecord = async (
  formData: FormData
): Promise<ApiResponse<any>> => {
  try {
    const response = await caseAPI.post<ApiResponse<any>>(
      "/api/case/record/upload/add",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    const { isSuccess, statusCode, message, result } = response.data;
    return { isSuccess, statusCode, message, result };
  } catch (error) {
    console.error("Error uploading case record:", error);
    throw new Error("Failed to upload case record. Please check the data.");
  }
};

export const fetchNotesCategoryList = async (): Promise<
  DocumentTypeOption[]
> => {
  try {
    const response = await caseAPI.get("/api/case/notes/category/list");
    const list = response.data?.result.map((item: any) => ({
      value: item.id,
      label: item.notesCategoryName,
    }));
    return list;
  } catch (error) {
    console.error("Error uploading case record:", error);
    throw new Error("Failed to upload case record. Please check the data.");
  }
};
